"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nibionno": {
    "ba5263eb": [{
      "hkey": "44cde223",
      "slug": "tabiago-cibrone",
      "name": "Tabiago-Cibrone",
      "primary": true,
      "skipSearch": false
    }],
    "cibrone": [{
      "hkey": "44cde223",
      "slug": "tabiago-cibrone",
      "name": "Tabiago-Cibrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "nibionno"
    }],
    "bcc09305": [{
      "hkey": "44cde223",
      "slug": "tabiago-cibrone",
      "name": "Tabiago-Cibrone",
      "primary": true,
      "skipSearch": false
    }],
    "tabiago": [{
      "hkey": "44cde223",
      "slug": "tabiago-cibrone",
      "name": "Tabiago-Cibrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;